import CancelSvg from "assets/images/cancel.svg";
import classNames from "classnames";
import { Motion } from "components/common";
import { useNavigate } from "react-router-dom";
import { Button } from "../buttons/Button";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import type { ReactNode } from "react";

interface FailedResultProps {
  title: string;
  description: string;
  actionLink: string;
  actionLabel: string;
  descriptionTextWidth?: string;
  secondaryAction?: {
    label: string;
    link: string;
  };
  footer?: ReactNode;
}

export const FailedResult: React.FC<FailedResultProps> = ({
  title,
  description,
  actionLabel,
  actionLink,
  descriptionTextWidth = "w-full xs:w-1/2",
  secondaryAction,
  footer,
}: FailedResultProps) => {
  const navigate = useNavigate();

  return (
    <>
      <img src={CancelSvg} alt="fail" className="w-40 h-40" />

      <Motion className="title-0" property="y" type="div">
        {title}
      </Motion>

      <Motion
        type="div"
        className={classNames("mt-12 mx-auto text-regular-1", descriptionTextWidth)}
        delayValue={0.1}
        property="y"
      >
        <div className="flex flex-col gap-6 ">
          <Motion type="div" delayValue={0.2} property="y">
            {description}
          </Motion>
        </div>

        <Motion
          className="mt-5 px-[10vw] flex flex-col gap-3"
          type="div"
          delayValue={0.4}
          property="y"
        >
          <Button onClick={() => navigate(actionLink)}>
            <HiOutlineArrowSmRight />
            {actionLabel}
          </Button>
          {secondaryAction ? (
            <Button color="gray" onClick={() => navigate(secondaryAction.link)}>
              {secondaryAction.label}
            </Button>
          ) : null}
        </Motion>

        {footer ? (
          <Motion type="div" delayValue={0.5} property="y" className="mt-6">
            {footer}
          </Motion>
        ) : null}
      </Motion>
    </>
  );
};
